import { render, staticRenderFns } from "./FirmAssignments.vue?vue&type=template&id=7ff08f8e"
import script from "./FirmAssignments.vue?vue&type=script&lang=js"
export * from "./FirmAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports